import React, { createContext, useContext, useState } from 'react';
const LangContext = createContext();

export const TX = {
  shopNow:{hi:'अभी खरीदें',en:'Shop Now'}, addToCart:{hi:'कार्ट में जोड़ें',en:'Add to Cart'}, buyNow:{hi:'अभी खरीदें',en:'Buy Now'},
  cart:{hi:'टोकरी',en:'Cart'}, emptyCart:{hi:'टोकरी खाली है',en:'Cart is Empty'},
  subtotal:{hi:'उप-योग',en:'Subtotal'}, gst:{hi:'GST (18%)',en:'GST (18%)'}, shipping:{hi:'शिपिंग',en:'Shipping'},
  total:{hi:'कुल',en:'Total'}, free:{hi:'मुफ़्त',en:'FREE'}, cod:{hi:'कैश ऑन डिलीवरी',en:'Cash on Delivery'},
  placeOrder:{hi:'ऑर्डर दें',en:'Place Order'}, jayShriRam:{hi:'जय श्री राम 🙏',en:'Jai Shri Ram 🙏'},
  login:{hi:'लॉगिन',en:'Login'}, register:{hi:'पंजीकरण',en:'Register'}, logout:{hi:'लॉगआउट',en:'Logout'},
  myOrders:{hi:'मेरे ऑर्डर',en:'My Orders'}, profile:{hi:'प्रोफाइल',en:'Profile'}, wishlist:{hi:'इच्छा सूची',en:'Wishlist'},
  inStock:{hi:'स्टॉक में है',en:'In Stock'}, outOfStock:{hi:'स्टॉक खत्म',en:'Out of Stock'},
  reviews:{hi:'समीक्षाएं',en:'Reviews'}, apply:{hi:'लगाएं',en:'Apply'}, couponCode:{hi:'कूपन कोड',en:'Coupon Code'},
  disclaimer:{hi:'ये सेवाएं वैदिक ज्योतिष परंपरा पर आधारित मार्गदर्शन के लिए हैं। परिणाम की कोई गारंटी नहीं।', en:'These services are for guidance based on Vedic astrology tradition. No guarantee of results.'},
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('rpb_lang') || 'hi');
  const toggleLang = () => { const nl = lang === 'hi' ? 'en' : 'hi'; setLang(nl); localStorage.setItem('rpb_lang', nl); };
  const t = (obj) => { if (!obj) return ''; if (typeof obj === 'string') return obj; return obj[lang] || obj.en || obj.hi || ''; };
  return <LangContext.Provider value={{ lang, setLang, toggleLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
